import script from "./RightDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RightDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./RightDrawer.vue?vue&type=style&index=0&id=3e5048e2&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5048e2"]])

export default __exports__